/**
 * AURA website templates: the two templates from the owner's HTML designs ("Classic Atelier / 经典简约",
 * "Luxury Editorial / 奢华杂志") — gallery names, Luxury colour scheme, team specialties, portfolio category tags.
 * One row per key: [key, English, 中文]; Malay falls back to English. Registered in ../modules.ts.
 */
const ROWS = [
  ["w7.web.tplName.atelier", "Classic Atelier", "经典简约"],
  ["w7.web.tplDesc.atelier", "Warm paper tones, serif headings and generous space: lookbook, service menu, packages, team, products and visit details.", "温暖纸色、衬线标题与舒展留白：作品集、服务价目、配套、团队、产品与到店指南。"],
  ["w7.web.tplName.luxury", "Luxury Editorial", "奢华杂志"],
  ["w7.web.tplDesc.luxury", "A magazine-style luxury site: full-screen hero, lookbook with filters, service rituals, artist picker, club card and product stage.", "杂志风奢华官网：全屏主图、可筛选作品集、服务仪式菜单、造型师切换、会员卡与产品陈列。"],
  ["ax.scheme", "Colour scheme (Luxury Editorial)", "配色模式（奢华杂志）"],
  ["ax.scheme.template", "Design (light + dark sections)", "按设计（明暗交替）"],
  ["ax.scheme.light", "All light", "全浅色"],
  ["ax.scheme.dark", "All dark", "全深色"],
  ["ax.specialties", "Specialties", "擅长"],
  ["ax.specialtiesPh", "Specialties, e.g. Cuts · Colour (shown under the name)", "擅长，例如：护理 · 造型（显示在名字下方）"],
  ["ax.imgCategory", "Category", "作品分类"],
  ["ax.imgCategoryHint", "Lookbook filter (Luxury Editorial template)", "作品集筛选（奢华杂志模板）"],
  ["ax.imgCategoryNone", "No category", "未分类"],
  // (AURA defaults) the designs' photos + copy as default content, replaceable per block
  ["ay.defaultImg", "Template photo (shown until you replace it)", "模板默认图片（更换前会显示在网站上）"],
  ["ay.replace", "Replace", "更换图片"],
  ["ay.reset", "Reset to default", "恢复默认"],
  ["ay.noImages", "No photos yet: upload one.", "还没有图片：请上传。"],
  ["ay.looks", "Lookbook items", "精选造型"],
  ["ay.addLook", "Add look", "添加造型"],
  ["ay.resetLooks", "Reset to the template's looks", "恢复模板默认造型"],
  ["ay.aboutImg", "About photo", "关于我们图片"],
  ["ay.moodImg", "Mood photo (next to the menu)", "氛围图片（服务菜单旁）"],
] as const;
export type AxKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<AxKey, string>;

export const taskAX = { en: col(1), zh: col(2), ms: col(1) };
